import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Twitter, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1">
            <Link to="/" className="inline-block">
              <img 
                src="/logo-footer.png" 
                alt="Gorito Fine Arts" 
                className="h-[66px] w-auto"
              />
            </Link>
            <p className="mt-4 text-sm text-gray-600 leading-relaxed">
              Original paintings and fine art prints from Sweden for art lovers worldwide.
            </p>
            <div className="flex space-x-4 mt-6">
              <a href="#" className="text-gray-400 hover:text-black transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-black transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-black transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-medium text-gray-900 uppercase tracking-wider mb-4">Quick Links</h3>
            <ul className="space-y-3">
              <li><Link to="/" className="text-sm text-gray-600 hover:text-black transition-colors">Home</Link></li>
              <li><Link to="/collections" className="text-sm text-gray-600 hover:text-black transition-colors">Collections</Link></li>
              <li><Link to="/about" className="text-sm text-gray-600 hover:text-black transition-colors">About</Link></li>
              <li><Link to="/news" className="text-sm text-gray-600 hover:text-black transition-colors">News</Link></li>
              <li><Link to="/contact" className="text-sm text-gray-600 hover:text-black transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Collections */}
          <div>
            <h3 className="text-sm font-medium text-gray-900 uppercase tracking-wider mb-4">Collections</h3>
            <ul className="space-y-3">
              <li><Link to="/collections/water-meditation" className="text-sm text-gray-600 hover:text-black transition-colors">Water Meditation</Link></li>
              <li><Link to="/collections/portraits" className="text-sm text-gray-600 hover:text-black transition-colors">Portraits</Link></li>
              <li><Link to="/collections/war-collection" className="text-sm text-gray-600 hover:text-black transition-colors">War Series</Link></li>
              <li><Link to="/collections/kaleidoscope" className="text-sm text-gray-600 hover:text-black transition-colors">Kaleidoscope</Link></li>
              <li><Link to="/collections/t-shirts" className="text-sm text-gray-600 hover:text-black transition-colors">T-Shirts</Link></li>
            </ul>
          </div>

          {/* Contact & Newsletter */}
          <div>
            <h3 className="text-sm font-medium text-gray-900 uppercase tracking-wider mb-4">Stay Connected</h3>
            <p className="text-sm text-gray-600 mb-4">Subscribe for updates on new artwork and exclusive offers.</p>
            <div className="flex">
              <input
                type="email"
                placeholder="Your email"
                className="flex-1 px-4 py-2 text-sm border border-gray-300 rounded-l-md focus:outline-none focus:ring-1 focus:ring-black"
              />
              <button className="px-4 py-2 bg-black text-white text-sm hover:bg-gray-800 transition-colors rounded-r-md">
                <Mail className="w-4 h-4" />
              </button>
            </div>
            <div className="mt-6">
              <p className="text-sm text-gray-600">Contact: hello@gorito.com</p>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-gray-500">
              © {new Date().getFullYear()} Gorito Fine Arts. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="#" className="text-sm text-gray-500 hover:text-black transition-colors">Privacy Policy</a>
              <a href="#" className="text-sm text-gray-500 hover:text-black transition-colors">Terms of Service</a>
              <a href="#" className="text-sm text-gray-500 hover:text-black transition-colors">Shipping Info</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
